import {AlgChannelService} from "./channel.service";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import { ApiVisa } from '../../../shared/api-visa.model';
import { Core2Config } from "../../../shared";

@Injectable({providedIn: "root"})
export class WebService extends AlgChannelService {

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE +"webchat-api/send";
    this.endpointPath =Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'webchat-api/send';
    this.httpClient = httpClient;
  }

  /**
   * Methods to receive message sent by user/customer from web chat component.
   */

  public receiveMessage(data: any, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +
     Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'webchat-api/receive';
    return this.httpClient.post(
      url,
      data,
      this.getHttpHeader(apiVisa)
    );
  }

  public receiveMediaMessage(data: any, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +
     Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'webchat-api/receive/media';
    return this.httpClient.post(
      url,
      data,
      this.getMultiPartFormHttpHeader(apiVisa)
    );
  }

  public initiateConversationForLoginSubject(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl.replace('send', 'new-conversation/login-subject');
    return this.httpClient.post(
      url,
      data,
      this.getHttpHeader(apiVisa)
    );
  }

  public initiateConversationForGuest(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl.replace('send', 'new-conversation/guest');
    return this.httpClient.post(
      url,
      data,
      this.getHttpHeader(apiVisa)
    );
  }

  public closeConversation(data: any, apiVisa: ApiVisa) {
    this.setApiUrl(apiVisa);
    const url = this.apiUrl.replace('send', 'close-conversation');
    return this.httpClient.post(
      url,
      data,
      this.getHttpHeader(apiVisa)
    );
  }

}
